import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { EmptyStateTitle } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface EmailTemplatesNoResultsStateProps {
  onClear: () => void;
}

/** Templates exist, but the active search filters them all out. */
export function EmailTemplatesNoResultsState({ onClear }: EmailTemplatesNoResultsStateProps) {
  const { t } = useTranslation('knowledge');

  return (
    <Empty role="status" data-testid="email-templates-no-results-state" className="flex-1">
      <EmptyHeader>
        <EmptyStateTitle>
          {t('knowledgeHub.emailTemplatesList.noMatchingTemplates')}
        </EmptyStateTitle>
        <EmptyDescription>
          {t('knowledgeHub.emailTemplatesList.tryADifferentSearchTerm')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" onClick={onClear}>
          {t('knowledgeHub.emailTemplatesList.clearSearch')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
